// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__h2oS4","item":"MainMenu_item__h82oo","link":"MainMenu_link__l8l-8","active":"MainMenu_active__yVZQ1"};